module.exports = __webpack_public_path__ + "static/img/learning-level3.2c44d1fb.png";